Vue.component("checkbox", {
    props: ['title', 'name', 'value'],
    data: function () {
        return {
            checked: false
        };
    },
    mounted: function () {
        var _this = this;

    },
    methods: {

    },
    template: '<div class=\"form__checkbox-holder\">\
                <input type=\"checkbox\" :id=\"name\" :name=\"name\" class=\"form__checkbox-input\"  :value=\"value\">\
                <label :for=\"name\" class=\"form__checkbox-label\">\
                    <span class=\"form__checkbox-phseudocheckbox\">\
                        <svg class=\"form__checkbox-icon\">\
                            <use xlink:href=\"~/m/i/icons.svg#symbol-check\"></use>\
                        </svg>\
                    </span>\
                    <span class=\"form__checkbox-label-text\">{{title}}</span>\
                </label>\
            </div>\
'
});